var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.127 7.528c1.007-2.638 4.74-2.638 5.746 0a3.075 3.075 0 0 0 4.697 1.38c2.273-1.676 5.413.342 4.833 3.106a3.075 3.075 0 0 0 3.206 3.7c2.818-.18 4.368 3.214 2.387 5.226a3.075 3.075 0 0 0 .696 4.845c2.468 1.372 1.937 5.066-.817 5.687a3.075 3.075 0 0 0-2.034 4.453c1.335 2.489-1.11 5.31-3.762 4.342a3.075 3.075 0 0 0-4.118 2.647c-.223 2.815-3.804 3.866-5.513 1.619a3.075 3.075 0 0 0-4.896 0c-1.709 2.247-5.29 1.196-5.512-1.619a3.075 3.075 0 0 0-4.119-2.647c-2.653.967-5.097-1.853-3.762-4.342a3.075 3.075 0 0 0-2.034-4.453c-2.754-.62-3.285-4.315-.817-5.687a3.075 3.075 0 0 0 .696-4.845c-1.981-2.012-.43-5.407 2.387-5.227a3.075 3.075 0 0 0 3.206-3.7c-.58-2.763 2.56-4.78 4.833-3.105a3.075 3.075 0 0 0 4.697-1.38z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.933 22.233 23.4 31.767l-4.334-4.334",
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 26,
    y1: 2,
    x2: 26,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.aa137093d09500f9b71508984a84f03a.svg";
export { ForwardRef as ReactComponent };